export default __webpack_public_path__ + "static/media/sa100-icon.2286b199.svg";